import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import Moment from 'moment';

export const baseURI = '/recaudacion/sectores-de-multas/';

/**
 * GET SectoresDeMultaes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getSectoresDeMultas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET SectorDeMulta
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getSectorDeMulta = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST SectorDeMulta
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSectorDeMulta = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, valuesEntidad);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SectorDeMulta
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchSectorDeMulta = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE SectorDeMulta
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteSectorDeMulta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
